const vi = {
  // Navbar
  nav_home: "Trang chủ",
  nav_about: "Về Chú Tenten",
  nav_services: "Dịch vụ & Giá",
  nav_flow: "Quy trình",
  nav_testimonials: "Đánh giá",
  nav_faq: "Câu hỏi thường gặp",
  nav_contact: "Liên hệ",
  nav_cta: "Đặt lịch xem tên",
  nav_subtitle: "Xem tên · Okinawa",
  nav_title: "Văn phòng Chú Tenten",

  // Hero
  hero_headline1: "Giữa bình yên",
  hero_headline2: "trên đảo Okinawa",
  hero_headline3: "chúng tôi lắng nghe",
  hero_headline4: "tiếng nói của tên bạn",
  hero_body: "Lịch xem tên thường kín chỗ nhiều tháng trước\nMỗi tháng tôi đích thân đến đảo Okinawa\nđể truyền đạt tên của bạn đến thầy",
  hero_pill1: "Không cần đổi tên",
  hero_pill2: "100% trực tuyến",
  hero_pill3: "Kết quả trong 1 tháng",
  hero_pill4: "100 suất mỗi tháng",
  hero_btn_apply: "Đặt lịch xem tên",
  hero_btn_services: "Xem dịch vụ",
  hero_scroll: "Cuộn xuống",

  // About
  about_heading: "Về Chú Tenten",
  about_intro: "Trên <strong>đảo Ikei</strong> yên bình giữa biển ấm Okinawa\ncó một người đàn ông thắp lên ánh sáng nhỏ cho mỗi cái tên\nMọi người trìu mến gọi ông là <strong>\"Chú Tenten\"</strong>",
  about_block1_label: "Từ nhân viên ngân hàng đến người xem tên",
  about_block1_text: "Chú Tenten từng là nhân viên ngân hàng\nNhờ sự chăm chỉ, ông trở thành <strong>trưởng chi nhánh trẻ nhất</strong> công ty\nQua nhiều lần gặp gỡ mọi người, một câu hỏi nảy sinh trong lòng ông",
  about_block1_quote: "\"Tại sao một số người dường như có gió đẩy về phía trước dù làm việc chăm chỉ như nhau?\"",
  about_block1_sub: "Câu hỏi nhỏ đó trở thành khởi đầu của một khám phá vĩ đại",
  about_block2_label: "Trí tuệ cổ xưa và ánh sáng bình yên",
  about_block2_text: "Ông dành toàn bộ thời gian rảnh nghiên cứu sách cổ về xem tên, tìm hiểu tỉ mỉ về nét chữ Kanji truyền thống và dòng chảy âm thanh",
  about_block2_text2: "Ông nhận ra rằng <strong>\"dấu tenten có thể điều chỉnh nhẹ nhàng dòng chảy của tên\"</strong>",
  about_block2_sub: "Đây không phải phép màu kịch tính, không phải công thức thành công thần kỳ\nMà là con đường nhẹ nhàng giúp ánh sáng trong bạn hiện rõ hơn",
  about_block3_label: "Truyền miệng — Đã chờ 6 tháng",
  about_block3_text: "Sự ấm áp trong cách xem của ông lan rộng qua truyền miệng, và giờ đây <strong>câu hỏi đổ về từ khắp nơi không ngừng nghỉ</strong>\nÔng đối xử với mọi người bằng cùng một tấm lòng, dù nổi tiếng hay không\nĐặt tay lên mỗi cái tên và đồng hành cùng cuộc sống của mọi người\nĐó là cách của Chú Tenten",

  // Gallery
  gallery_heading: "Thư viện ảnh",
  gallery_sub: "Okinawa · Đảo Ikei",

  // Services
  services_heading: "Dịch vụ & Giá",
  services_note1: "※ Tất cả gói đã bao gồm phí xem của thầy và phí đại diện",
  services_note2: "※ Không có chi phí phát sinh thêm, bạn có thể yên tâm",
  services_tab1: "Tên cá nhân",
  services_tab2: "Tên doanh nghiệp",
  services_tab3: "Tên thú cưng",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Chúng tôi nhẹ nhàng xem xét sự phát triển, môi trường và chuyển động của tâm hồn bạn, rồi thêm dấu tenten phù hợp nhất",
  services_tab2_desc: "Mang làn gió nhẹ đến thử thách mới, điều chỉnh nhẹ nhàng dòng chảy của doanh nghiệp",
  services_tab3_desc: "Dành cho thành viên gia đình luôn ở bên bạn, tặng tên đầy bình yên và ấm áp",
  services_row1_target1: "Từ 16 tuổi trở lên",
  services_row1_target2: "4-15 tuổi",
  services_row1_target3: "0-3 tuổi",
  services_row2_target1: "Tên thương hiệu / Công ty / Cửa hàng",
  services_row3_target1: "Tên thú cưng",
  services_col_target: "Đối tượng",
  services_col_price: "Giá (đã bao gồm thuế)",
  services_cta: "Đặt dịch vụ này",
  services_includes_title: "Bao gồm trong giá (tất cả)",
  services_inc1: "Xem tên",
  services_inc2: "Gợi ý dấu tenten tốt nhất",
  services_inc3: "Gửi thẻ cỡ danh thiếp (miễn phí nếu muốn)",
  services_inc4: "Lời khuyên may mắn",
  services_inc5: "Ảnh kỹ thuật số của thẻ tên",
  services_includes_note: "Mục đích của việc xem là nhẹ nhàng khơi dậy phép màu đã có sẵn trong tên bạn",
  services_payment_title: "Phương thức thanh toán",
  services_payment_method: "Chuyển khoản ngân hàng (thanh toán trước)",
  services_payment_desc: "Sau khi đăng ký, chúng tôi sẽ cung cấp thông tin tài khoản ngân hàng\nKhi thanh toán hoàn tất, dòng chảy may mắn sẽ bắt đầu tụ lại bình yên",
  services_first_title: "Dành cho người lần đầu",
  services_first_desc: "Cảm giác không chắc chắn là điều bình thường\nCảm giác đó là tín hiệu bên trong\nrằng đã đến lúc bắt đầu thay đổi nhẹ nhàng",
  services_first_cta: "Bắt đầu bằng tư vấn",

  // Flow
  flow_heading: "Quy trình dịch vụ",
  flow_step1_title: "Gửi biểu mẫu",
  flow_step1_c1: "Điền thông tin cần thiết vào biểu mẫu chuyên dụng",
  flow_step1_c2: "Chúng tôi sẽ phản hồi trong 2-3 ngày làm việc sau khi gửi",
  flow_step1_c3: "Email sẽ có các bước tiếp theo và hướng dẫn chuyển khoản",
  flow_step2_title: "Chuyển phí xem tên",
  flow_step2_c1: "Chuyển phí xem tên vào tài khoản được chỉ định trong email phản hồi",
  flow_step2_c2: "Sau khi xác nhận thanh toán, chúng tôi sẽ bắt đầu chuẩn bị theo thứ tự",
  flow_step3_title: "Thông báo chuyển khoản",
  flow_step3_c1: "Sau khi chuyển khoản, gửi ảnh biên lai đến địa chỉ được chỉ định trong email",
  flow_step3_c2: "Sau khi xác nhận, chúng tôi sẽ gửi tin nhắn \"Đăng ký hoàn tất\"",
  flow_step3_note: "Nếu không có thông báo này, chúng tôi không thể bắt đầu xem. Vui lòng gửi chắc chắn",
  flow_step4_title: "Nhận kết quả xem",
  flow_step4_c1: "Sau khi xem xong, chúng tôi sẽ gửi ảnh thẻ tên và dấu tenten qua email trong khoảng một tuần",
  flow_step4_c2: "Sau đó sẽ gửi báo cáo xem chi tiết và lời khuyên may mắn qua email",
  flow_step5_title: "Gửi thẻ tên (tùy chọn)",
  flow_step5_c1: "Nếu muốn, chúng tôi sẽ gửi thẻ cỡ danh thiếp được thầy viết tay qua bưu điện",
  flow_step5_c2: "Vui lòng điền địa chỉ bưu điện chính xác vào ô địa chỉ của biểu mẫu",
  flow_step5_note: "Nếu không cần thẻ, chỉ cần điền tên thành phố nơi bạn sống",
  flow_banner_title: "Tất cả trực tuyến, từ bất kỳ đâu tại Nhật Bản",
  flow_banner_desc: "Không cần đích thân đến đảo Ikei ở Okinawa\nBạn có thể bắt đầu ngay mà không cần thay đổi thói quen hàng ngày",
  flow_banner_cta: "Đăng ký ngay",

  // Testimonials
  testimonials_heading: "Đánh giá từ khách hàng",
  testimonials_viewing: "Đang xem",

  // FAQ
  faq_heading: "Câu hỏi thường gặp",
  faq_cta_title: "Còn câu hỏi nào khác?",
  faq_cta_desc: "Câu hỏi nhỏ cũng được chào đón\nCâu hỏi mà bạn có thể cảm thấy ngại — đó chính là điều chúng tôi muốn nghe nhất",
  faq_cta_btn: "Đặt câu hỏi",

  // CTA Banner
  cta_heading1: "Miễn phí",
  cta_heading2: "Tư vấn",
  cta_btn: "Đặt lịch ngay",

  // Contact
  contact_heading: "Liên hệ",
  contact_desc: "Gửi yêu cầu xem tên hoặc câu hỏi qua biểu mẫu này. Thông thường chúng tôi phản hồi trong 2-3 ngày làm việc",
  contact_address_label: "Địa chỉ",
  contact_address_value: "Tochigi, Nhật Bản (Trực tuyến · Phục vụ toàn quốc)",
  contact_email_label: "Email",
  contact_hours_label: "Giờ làm việc",
  contact_hours_value: "Thứ 2–6 9:00–18:00 (Nghỉ thứ 7/CN/ngày lễ)",
  contact_note_title: "Về phản hồi",
  contact_note_desc: "Phản hồi có thể vào thư mục spam\nNếu không nhận được phản hồi trong 2-3 ngày làm việc, vui lòng liên hệ trực tiếp qua email",
  contact_field_name: "Họ tên",
  contact_field_furigana: "Furigana (cách đọc tên)",
  contact_field_email: "Địa chỉ email",
  contact_field_phone: "Số điện thoại",
  contact_field_service: "Dịch vụ mong muốn",
  contact_field_message: "Tin nhắn",
  contact_placeholder_name: "Nguyễn Văn A",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+84 00 000 0000",
  contact_placeholder_message: "Vui lòng nhập tên muốn xem hoặc câu hỏi và yêu cầu của bạn",
  contact_select_placeholder: "Chọn",
  contact_service1: "Tên cá nhân",
  contact_service2: "Tên doanh nghiệp",
  contact_service3: "Tên thú cưng",
  contact_service4: "Khác / Hỏi thêm",
  contact_submit: "Gửi",
  contact_submitting: "Đang gửi...",
  contact_privacy: "Thông tin cá nhân gửi qua biểu mẫu chỉ được sử dụng cho dịch vụ xem tên",
  contact_error: "Gửi thất bại. Vui lòng thử lại sau hoặc liên hệ trực tiếp qua email",
  contact_err_name: "Vui lòng nhập họ tên của bạn",
  contact_err_email_required: "Vui lòng nhập địa chỉ email của bạn",
  contact_err_email_invalid: "Vui lòng nhập địa chỉ email hợp lệ",
  contact_err_service: "Vui lòng chọn dịch vụ",
  contact_err_message_required: "Vui lòng nhập tin nhắn",
  contact_err_message_limit: "Tin nhắn không được vượt quá 500 ký tự",
  contact_thanks_title: "Đã gửi tin nhắn",
  contact_thanks_desc: "Cảm ơn bạn đã liên hệ\nSau khi xem xét tin nhắn của bạn, chúng tôi sẽ phản hồi trong <strong>2-3 ngày làm việc</strong>\nVui lòng chờ đợi",
  contact_thanks_check1: "Kiểm tra email xác nhận",
  contact_thanks_check2: "Kiểm tra cả thư mục spam",
  contact_thanks_check3: "Chờ phản hồi trong 2-3 ngày làm việc",
  contact_thanks_another: "Gửi tin nhắn khác",

  // Footer
  footer_subtitle: "Xem tên · Okinawa",
  footer_title: "Văn phòng Chú Tenten",
  footer_desc: "Từ Okinawa đến toàn quốc, thầy xem tên với hơn 50 năm kinh nghiệm đọc vận mệnh ẩn trong tên của bạn một cách cẩn thận",
  footer_contact_title: "Thông tin liên hệ",
  footer_address_label: "Địa chỉ",
  footer_address_value: "Tochigi, Nhật Bản\n(Trực tuyến · Phục vụ toàn quốc)",
  footer_email_label: "Email",
  footer_hours_label: "Giờ làm việc",
  footer_hours_value: "Thứ 2–6 9:00–18:00\n(Nghỉ thứ 7/CN/ngày lễ)",
  footer_nav_title: "Điều hướng",
  footer_copyright: "© 2025 Văn phòng Chú Tenten. Bảo lưu mọi quyền",
  footer_privacy: "Chính sách bảo mật",
  footer_law: "Luật thương mại đặc biệt",
  footer_sitemap: "Sơ đồ trang web",
};

export default vi;
